import { QueryClient } from 'react-query';
import Dashboard from '../../Constants/Endpoints/Dashboard';
import GetReportsForUserByCurrentToken from '../../Interfaces/Requests/Dashboard/GetReportsForUserByCurrentToken';
import Report from '../../Interfaces/Responses/Dashboard/Report';
import AxiosUtil from '../../Utils/AxiosUtil';

export const REPORT_GROUPS_QUERY_KEY = 'reportGroups';

export const buildReportGroupsQueryKey = (currentToken?: string) => [
    REPORT_GROUPS_QUERY_KEY,
    currentToken,
];

export const getReportsForUserByCurrentToken = async (currentToken: string): Promise<Report[]> => {
    const url = `${process.env.REACT_APP_API_ROOT}${Dashboard.GET_REPORTS_FOR_USER_BY_CURRENT_TOKEN}`;
    const requestData: GetReportsForUserByCurrentToken = {
        gru_token: currentToken,
    };

    return await AxiosUtil.get<Report[], GetReportsForUserByCurrentToken>(url, requestData);
};

export const invalidateReportMenu = (queryClient: QueryClient) => {
    void queryClient.invalidateQueries(REPORT_GROUPS_QUERY_KEY);
};
